import { render, staticRenderFns } from "./mo-textarea.html?vue&type=template&id=8baa463e&external"
import script from "./mo-textarea.ts?vue&type=script&lang=ts&external"
export * from "./mo-textarea.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8baa463e')) {
      api.createRecord('8baa463e', component.options)
    } else {
      api.reload('8baa463e', component.options)
    }
    module.hot.accept("./mo-textarea.html?vue&type=template&id=8baa463e&external", function () {
      api.rerender('8baa463e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-textarea/mo-textarea.vue"
export default component.exports